var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.938397V12.8217C0 13.34 0.420135 13.7601 0.938397 13.7601C1.45666 13.7601 1.87679 13.34 1.87679 12.8217V7.67946H9.44695V12.8217C9.44695 13.34 9.86709 13.7601 10.3853 13.7601C10.9036 13.7601 11.3237 13.34 11.3237 12.8217V1.86866V1.62501H19.2511V2.55934V5.48067H21.1319V0.93433C21.1319 0.418314 20.7043 0 20.1768 0H10.2818C9.82073 0 9.44695 0.373781 9.44695 0.834863V6.08067H1.87679V0.938397C1.87679 0.420135 1.45666 0 0.938397 0C0.420135 0 0 0.420134 0 0.938397Z",
    fill: "url(#paint0_linear_3625_31487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2511 12.8402C19.2511 13.3483 19.6721 13.7601 20.1915 13.7601C20.7108 13.7601 21.1319 13.3483 21.1319 12.8402V7.5L19.2511 7.67946V12.8402Z",
    fill: "url(#paint1_linear_3625_31487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0899 17.752L17.0899 17.7521L17.0998 17.7572C18.2097 18.3234 19.4518 18.6 20.8128 18.6C21.9838 18.6 23.0601 18.3883 24.0315 17.9532L24.0316 17.9532L24.0393 17.9496C24.7312 17.6278 25.3281 17.2 25.8222 16.6642C26.424 16.0115 26.1434 15.0822 25.5146 14.6848C24.8817 14.2849 24.126 14.4834 23.6727 14.9164L24.0871 15.3503L23.6727 14.9164C23.3829 15.1932 23.0542 15.4128 22.6836 15.5765C22.1103 15.8299 21.481 15.9597 20.7882 15.9597C19.9582 15.9597 19.2284 15.7884 18.5861 15.4574C17.9431 15.1108 17.4428 14.637 17.0743 14.0306C16.7137 13.4369 16.5226 12.7251 16.5226 11.873C16.5226 11.0209 16.7137 10.3091 17.0743 9.71541C17.4423 9.10968 17.9413 8.64471 18.5818 8.31368L18.5818 8.31375L18.5904 8.30915C19.2321 7.96422 19.9602 7.78625 20.7882 7.78625C21.481 7.78625 22.1103 7.91607 22.6836 8.16943C23.0521 8.33227 23.3798 8.55388 23.6694 8.83636C24.1213 9.27728 24.883 9.48309 25.5214 9.07968C26.1455 8.68531 26.4292 7.76416 25.8359 7.11026C25.3378 6.56122 24.7337 6.13015 24.0315 5.81564C23.0601 5.38051 21.9838 5.1688 20.8128 5.1688C19.4518 5.1688 18.2097 5.4454 17.0998 6.01165L17.0998 6.01164L17.0963 6.01347C16.0061 6.57877 15.1378 7.3672 14.5051 8.37642C13.865 9.39719 13.5533 10.5696 13.5533 11.873C13.5533 13.1629 13.8658 14.3331 14.5027 15.3658L14.5027 15.3658L14.5051 15.3695C15.1369 16.3772 16.003 17.1718 17.0899 17.752Z",
    stroke: "url(#paint2_linear_3625_31487)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3625_31487",
    x1: 13.833,
    y1: -0.860009,
    x2: 21.1367,
    y2: 13.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3625_31487",
    x1: 13.833,
    y1: -0.860009,
    x2: 21.1367,
    y2: 13.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3625_31487",
    x1: 21.8264,
    y1: 5.00435,
    x2: 29.5922,
    y2: 14.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsIcon);
export default __webpack_public_path__ + "static/media/nps_icon.3f74fc72797742453ab663dfa47aca11.svg";
export { ForwardRef as ReactComponent };